module.exports = __webpack_public_path__ + "img/pic2.95710477.png";